import React, { Component } from 'react';

import styles from './styles.less';

export default class ActivityIndicator extends Component {
	render() {
		return <i className={styles.activityIndicator} />;
	}
}
